import React from 'react';
import { useTranslation } from 'react-i18next';
import { AlignRightIcon, ArchiveIcon, MagicWandIcon } from '@fronton/icons-react';
import { Banner, BannerContent, BannerHeader, BannerListItem, BannerMedia } from 'common/components/banner';
import { STORAGE_CDN_PATH, STORAGE_ELEMENT_BLOCK } from '../../storage-constants';
import { spaceoBannerContent, spaceoBannerLogo } from './storage-spaceo-banner-styles';

export const StorageSpaceoBanner = () => {
  const { t } = useTranslation();

  return (
    <Banner
      bgColor="linear-gradient(90deg, #596274 11.91%, #4E5D73 100%)"
      elementBlock={`${STORAGE_ELEMENT_BLOCK} / spaceo`}
      link={{
        title: t('spaceo-banner.link-title'),
        href: '/promo/spaceo-kub/',
      }}
      promotion={{
        name: `${STORAGE_ELEMENT_BLOCK}_bottom`,
        creative: t('spaceo-banner.title'),
        position: '1',
      }}>
      <BannerMedia
        alt="Spaceo KUB"
        className={spaceoBannerLogo}
        srcD={`${STORAGE_CDN_PATH}/spaceo-kub/spaceo-d.jpg/spaceo-d.jpg`}
        srcT={`${STORAGE_CDN_PATH}/spaceo-kub/spaceo-t.jpg/spaceo-t.jpg`}
        src={`${STORAGE_CDN_PATH}/spaceo-kub/spaceo-m.jpg/spaceo-m.jpg`}
      />
      <BannerContent className={spaceoBannerContent}>
        <BannerHeader title={t('spaceo-banner.title')} />
        <BannerListItem
          itemList={[
            {
              leftIcon: <ArchiveIcon type="outline" size="l" color="text-invert" />,
              text: t('spaceo-banner.item-first'),
            },
            {
              leftIcon: <MagicWandIcon type="outline" size="l" color="text-invert" />,
              text: t('spaceo-banner.item-second'),
            },
            {
              leftIcon: <AlignRightIcon type="outline" size="l" color="text-invert" />,
              text: t('spaceo-banner.item-third'),
            },
          ]}
        />
      </BannerContent>
    </Banner>
  );
};
